<script>
  import {getContext} from 'svelte';
  import lang from './ConnectAccountTips.lang';

  const LG = getContext('LG');
</script>

<div class="cross-site-connect-tip">
  <div class="T4 mt16 mb12">{LG(lang.ConnectPhemexTipTitle)}</div>
  <div class="T3 mb12">{LG(lang.ConnectPhemexTip1)}</div>
  <div class="T3 mb12">{LG(lang.ConnectPhemexTip2)}</div>
  <div class="T3">{LG(lang.ConnectPhemexTip3)}</div>
</div>
